import React, { useState } from "react"
import UserImage from "../BookTour/UserImage"
import Form from "../BookTour/Form"
import * as s from "./Step3.module.less"
import isEmail from "validator/lib/isEmail"
import { isValidPhone } from "../../PhoneNumber"
import ProgressDots from "../../ProgressDots"
import submitGetInTouch from "../../../utils/submitGetInTouch"

const isDev = (value) => (process.env.NODE_ENV === "development" ? value : "")

const ContactForm = ({ space = {}, isCms = false, total_price = 0 }) => {
  const [name, setName] = useState(isDev("Mahesh Samudra"))
  const [email, setEmail] = useState(isDev("mahesh.samudra@worksimply.com"))
  const [phone, setPhone] = useState(isDev("7147147147"))
  const [message, setMessage] = useState(isDev("Test Message"))

  const [formSubmitted, setFormSubmitted] = useState(false)
  const [progress, setProgress] = useState(false)

  const handleSubmit = async () => {
    setProgress(true)

    const { formEmail: toEmail } = space

    const res = await submitGetInTouch({
      user: { name, phone, email, message },
      isCms,
      space,
      total_price,
      toEmail,
    })
    setProgress(false)
    setFormSubmitted(true)
  }

  if (formSubmitted) {
    return (
      <div>
        <h5>
          Thanks for getting in touch. An office space expert will reach out to
          you as soon as possible.
        </h5>
      </div>
    )
  }

  return (
    <div>
      <div className={s.user_data}>
        <h5>Get in Touch</h5>
        {space.id ? (
          <UserImage space={space} />
        ) : (
          <img
            src={require("../../../images/lauren-tapp.png").default}
            alt={"Lauren Tapp"}
          />
        )}
        <p>{space.contact_name || "Lauren Tapp"}</p>
        <Form
          step={3}
          space={space}
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          message={message}
          setMessage={setMessage}
          phone={phone}
          setPhone={setPhone}
          inline
          formOnly
          messageRequired
        />
        <div className={s.submit_block}>
          <button
            onClick={handleSubmit}
            className={`btn btn-primary submit_schedule_call ms-auto ${
              progress ? "submitting" : ""
            }`}
            disabled={
              !name ||
              !email ||
              !message ||
              !isEmail(email) ||
              progress ||
              !isValidPhone(phone, true)
            }
          >
            <ProgressDots active={progress} />
            Submit
          </button>
        </div>
      </div>
    </div>
  )
}

export default ContactForm
